import React from "react";
import { Game, Player, PlayerAction } from "./types";

type GameDetails = {
  player?: Player;
  game?: Game;
};

type GameConnection = {
  submit: (action: PlayerAction, noLoading?: boolean) => void;
};

export const GameContext: React.Context<GameConnection> = React.createContext({
  submit: (action) => {},
});
